/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import {
  Directive, ElementRef, OnInit, Output, EventEmitter, OnDestroy,
} from '@angular/core';

export interface ElementDimensions {
  height: number,
  width: number
}
@Directive({
  selector: '[bulbResizeObserver]',
  standalone: false,
})
/**
 * Directive used to detect height and width changes in the element it is used on and emits the height in pixels
 * to the component to allow for dynamic styling of the element. Currently used to detect height changes
 * on the page title to adjust the position of the element in accordance to the Add Cover Image/ Header
 * Image Controls button.
 */
export class ResizeObserverDirective implements OnInit, OnDestroy {

  private observer: ResizeObserver;

  @Output() resizeEventEmitter: EventEmitter<ElementDimensions> = new EventEmitter<ElementDimensions>();

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    this.observer = new ResizeObserver((entries) => {
      // window.requestAnimationFrame can be helpful to avoid infinite ResizeObserver loop.
      window.requestAnimationFrame((): void | undefined => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        entries.forEach((entry) => {
          this.resizeEventEmitter.emit({ height: entry.contentRect.height, width: entry.contentRect.width });
        });
      });
    });
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.unobserve(this.el.nativeElement);
  }
}
